export default "__VITE_ASSET__CMNaK5YQ__"